import styled from "styled-components"
import Container from "@mui/material/Container"

export const Wrapper = styled(Container)`
  padding-top: 2em;
  padding-bottom: 2em;
`
